import { createContext } from "react";
import type * as GeoJSONTypes from "geojson";

export interface PropertyForestSnapshotData {
  standsGeoJson: GeoJSONTypes.FeatureCollection | null;
  propertyBoundaryGeoJson: GeoJSONTypes.GeoJsonObject | null;
  bbox: [number, number, number, number] | null;
}

export interface PropertyForestSnapshot {
  context: PropertyForestSnapshotData | null;
  isLoading: boolean;
  error: string | null;
  /** Completed-read identity; does not imply a source observation date. */
  revisionKey?: string;
  /** Localized explanation for a terminal raster failure. */
  unavailableLabel?: string;
}

export const EMPTY_PROPERTY_FOREST_SNAPSHOT: PropertyForestSnapshot =
  Object.freeze({ context: null, isLoading: false, error: null });

export const PropertyForestSnapshotContext = createContext<
  Readonly<Record<string, PropertyForestSnapshot>>
>(Object.freeze({}));
